// import logo from './logo.svg';
import './App.css';
import  About  from "./component/About";
import { Contact } from "./component/Contact";
import { Github } from "./component/Github";
import { Home } from "./component/Home";
import { Navbar } from "./component/Navbar";
import { Projects } from "./component/Projects";
import { Skills } from "./component/Skill";

function App() {
  return (
    <div className='app'>
      <Navbar />
      <Home />
      <About />
      <Skills />
      <Projects />
      <Github />
      <Contact/>
    </div>
  );
}

export default App;
